// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portal-container{height:100%;overflow-y:hidden}`, "",{"version":3,"sources":["webpack://./src/components/UI/PopupWindow/PopupWindow.scss"],"names":[],"mappings":"AAAA,kBACC,WAAA,CACA,iBAAA","sourcesContent":[".portal-container {\n\theight: 100%;\n\toverflow-y: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
